export default __webpack_public_path__ + "static/media/crossIcon.c14c6663.svg";